var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, "\n                      {\" \"}\n                      ", /*#__PURE__*/React.createElement("path", {
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    stroke: "#000000",
    strokeWidth: 1.416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), "{\" \"}\n                      ", /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 11.84H14.3199C13.6099 11.84 13.1299 11.3 13.1299 10.65V9.15997C13.1299 8.50997 13.6099 7.96997 14.3199 7.96997H15.8099C16.4599 7.96997 16.9999 8.50997 16.9999 9.15997V11.84Z",
    stroke: "#000000",
    strokeWidth: 1.416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), "{\" \"}\n                      ", /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 11.8401C16.9999 14.6301 16.4799 15.1001 14.9099 16.0301",
    stroke: "#000000",
    strokeWidth: 1.416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), "{\" \"}\n                      ", /*#__PURE__*/React.createElement("path", {
    d: "M10.86 11.84H8.17999C7.46999 11.84 6.98999 11.3 6.98999 10.65V9.15997C6.98999 8.50997 7.46999 7.96997 8.17999 7.96997H9.66999C10.32 7.96997 10.86 8.50997 10.86 9.15997V11.84Z",
    stroke: "#000000",
    strokeWidth: 1.416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), "{\" \"}\n                      ", /*#__PURE__*/React.createElement("path", {
    d: "M10.86 11.8401C10.86 14.6301 10.34 15.1001 8.77002 16.0301",
    stroke: "#000000",
    strokeWidth: 1.416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), "{\" \"}\n                    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddQuote);
export default __webpack_public_path__ + "static/media/addQuote.1738fac19e4a2dc046fd258d976f5d93.svg";
export { ForwardRef as ReactComponent };